<template>
  <div>
    <v-col>
      <v-row>
        <v-col cols="6" sm="2" style="background-color: #1976D250;
            min-width: 150px;
            margin-right: 10px;
            border-color: #1976D2;
            border-bottom: 5px solid #49A94D; 
            border-radius: 5px;">
          <span>Economia Total</span>
          <h2>{{ getTotalEconomy }}</h2>
        </v-col>
        <v-col cols="6" sm="2" style="background-color: #1976D250;
            min-width: 150px;
            margin-right: 10px;
            border-color: #1976D2;
            border-bottom: 5px solid #1976D2; 
            border-radius: 5px;">
          <span>Economia Total</span>
          <h2>M³ {{ getTotalEconomyM3 }}</h2>
        </v-col>
        <v-col cols="6" sm="2" style="background-color: #1976D250; 
            min-width: 150px;
            margin-right: 10px;
            border-color: #1976D2;
            border-bottom: 5px solid #49A94D; 
            border-radius: 5px;">
          <span>Referencia Atual</span>
          <h2>{{ getLastReference }}</h2>
        </v-col>
        <v-col cols="6" sm="2" style="background-color: #1976D250;
            min-width: 150px;
            margin-right: 10px;
            border-color: #1976D2;
            border-bottom: 5px solid #1976D2; 
            border-radius: 5px;">
          <span>Média Antes da Foz</span>
          <h2>M³ {{ getAverageBeforeFoz }}</h2>
        </v-col>
        <v-col cols="6" sm="2" style="background-color: #1976D250;
            min-width: 150px;
            margin-right: 10px;
            border-color: #1976D2;
            border-bottom: 5px solid #1976D2; 
            border-radius: 5px;">
          <span>Média Atual</span>
          <h2>M³ {{ getAverageAfterFoz }}</h2>
        </v-col>
      </v-row>
    </v-col>
    <v-divider></v-divider>
    <v-col>
      <v-row>
        <div
          style="display:flex;border-radius: 10px;padding: 15px;justify-content: space-evenly;align-items: center;height:80px;width:360px;background-color: dodgerblue;">
          <div>
            <span style="font-size: 16px;font-weight: bold;color: white;">Data de Instalação</span>
          </div>
          <div>
            <span style="font-size: 16px;font-weight: bold;color: gold;">{{ getInstalattionDate }}</span>
          </div>
        </div>
        <div style="display: flex;justify-content: center;align-items: center;max-width: 70px;margin-left: 10px;">
          <installation-date-dialog
            :value="instalattionDate"
            :disabled="disabled || isSavingInstallationDate"
            :loading="isSavingInstallationDate"
            @save="saveInstalattionDate"
          />
        </div>
        <v-spacer></v-spacer>
        <div style="display: flex;justify-content: center;align-items: center;max-width: 70px;margin-left: 10px;">
          <v-btn color="primary" class="mb-2" @click="getAccountsCompesa()" :disabled="disabled"
            style="height: 100%;width: 100%;border-radius: 10px;margin: 0 !important;">
            Buscar <br /> Contas
          </v-btn>
        </div>
      </v-row>
    </v-col>

    <v-col>
      <v-data-table :headers="displayRecordHeaders" :items="listHistoricsWithFozTelemetry" class="historic-table elevation-0 rounded-lg" :items-per-page="6"
        :options.sync="historicTableOptions"
        :custom-sort="sortHistoricsForTable"
        no-data-text="Sem leituras para exibir">

        <template v-slot:top>
          <v-toolbar flat class="historic-table-toolbar rounded-lg">
            <v-toolbar-title>Histórico</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn color="primary" class="mb-2" text @click="newHistoricForm" :disabled="disabled">
              <v-icon>add</v-icon>
            </v-btn>
          </v-toolbar>
          <v-progress-linear v-if="fozConsumptionLoading" indeterminate height="2" color="primary" />
        </template>

        <template v-slot:body="{ items }">
          <tbody>
            <tr v-for="(historico, index) in items" :key="getHistoricRowKey(historico, index)">
              <td class="historic-date-cell">
                <div class="historic-status-chip">
                  <v-chip small :color="getColorMonth(historico)">
                    {{ getTagMonth(historico) }}
                  </v-chip>
                </div>
                <div class="historic-date-stack">
                  <span>Data</span>
                  <strong>{{ formatHistoricReadingDate(historico) }}</strong>
                </div>
              </td>

              <td>
                <div class="historic-competence">
                  {{ formatHistoricCompetence(historico) }}
                </div>
              </td>

              <td>
                <div class="historic-metric">
                  <strong>{{ formatNumber(historico.water_cubic_meters) }}</strong>
                  <span>m³</span>
                </div>
              </td>

              <td>
                <div class="historic-metric historic-metric-foz">
                  <span v-if="isFozTelemetryLoading(historico.fozTelemetry)" class="foz-metric-skeleton"></span>
                  <template v-else>
                    <strong>{{ formatFozTelemetryValue(historico.fozTelemetry, 'water') }}</strong>
                    <span>m³</span>
                  </template>
                </div>
              </td>

              <td>
                <div class="historic-metric">
                  <strong>{{ formatNumber(historico.sewer_cubic_meters) }}</strong>
                  <span>m³</span>
                </div>
              </td>

              <td>
                <div class="historic-metric historic-metric-foz">
                  <span v-if="isFozTelemetryLoading(historico.fozTelemetry)" class="foz-metric-skeleton"></span>
                  <template v-else>
                    <strong>{{ formatFozTelemetryValue(historico.fozTelemetry, 'sewer') }}</strong>
                    <span>m³</span>
                  </template>
                </div>
              </td>

              <td>
                <div class="historic-metric historic-metric-total">
                  <strong>{{ formatNumber(historico.consumption_cubic_meters) }}</strong>
                  <span>m³</span>
                </div>
              </td>

              <td>
                <div class="foz-total-cell">
                  <div class="historic-metric historic-metric-foz historic-metric-total">
                    <span v-if="isFozTelemetryLoading(historico.fozTelemetry)" class="foz-metric-skeleton"></span>
                    <template v-else>
                      <strong>{{ formatFozTelemetryValue(historico.fozTelemetry, 'total') }}</strong>
                      <span>m³</span>
                    </template>
                  </div>

                  <v-tooltip top v-if="shouldShowFozTotalAlert(historico)">
                    <template v-slot:activator="{ on, attrs }">
                      <v-chip v-bind="attrs" v-on="on" x-small label :class="getFozTotalVariationBadgeClass(historico)">
                        {{ formatFozTotalVariationPercentage(historico) }}
                      </v-chip>
                    </template>
                    <span>Variação de {{ formatFozTotalVariationPercentage(historico) }} entre Total FOZ e Concessionária</span>
                  </v-tooltip>
                </div>
              </td>

              <td>
                <div class="historic-metric historic-money">
                  <strong>{{ formatNumber(historico.cost_consumption) }}</strong>
                  <span>R$</span>
                </div>
              </td>

              <td>
                <div class="historic-metric historic-money">
                  <strong>{{ formatNumber(historico.reference_economy) }}</strong>
                  <span>R$</span>
                </div>
              </td>

              <td>
                <div class="historic-metric historic-money">
                  <strong>{{ formatNumber(historico.financial_economy) }}</strong>
                  <span>R$</span>
                </div>
              </td>

              <td v-if="hasCurrentBaselineConfig">
                <div class="historic-text-cell">
                  {{ formatHistoricDriverReference(historico) || "-" }}
                </div>
              </td>

              <td>
                <div class="historic-text-cell historic-observation">
                  {{ historico.observation || "-" }}
                </div>
              </td>

              <td>
                <div class="historic-file-cell">
                  <v-btn 
                    v-if="historico.path_file_photo_account"
                    class="historic-icon-button"
                    icon
                    small
                    color="primary"
                    :disabled="disabled"
                    @click="() => downloadFileFromList(historico)"
                  >
                    <v-icon small>mdi-file-pdf-box</v-icon>
                  </v-btn>
                  <span v-else class="grey--text text--lighten-1">
                    <v-icon small color="grey lighten-1">mdi-file-remove</v-icon>
                  </span>
                </div>
              </td>

              <td>
                <div class="historic-actions-cell">
                <v-btn 
                class="historic-icon-button"
                icon
                small
                elevation="0"
                :loading="loadingId === historico.month"
                @click="editHistoricForm(historico.month)"
                  :disabled="disabled">
                  <v-icon color="primary" small>
                    mdi-pencil
                  </v-icon>
                </v-btn>

                <v-btn 
                  class="historic-icon-button"
                  icon
                  small
                  elevation="0"
                  :loading="loadingId === historico.month"
                  @click="callDialogAlert(historico.month)"
                  :disabled="disabled">
                  <v-icon color="primary" small>
                    mdi-delete
                  </v-icon>
                </v-btn>
                </div>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </v-col>

    <v-dialog v-model="dialog" max-width="450">
      <v-card>
        <v-card-title class="text-h5">
          {{ titleForm }}
        </v-card-title>

        <v-card-text>
          <v-form ref="form" v-model="valid">
            <v-row>
              <v-col cols="6">
                <historic-reading-date :instalattionDate="instalattionDate" :month="historicForm.month"
                  :day="historicForm.day" :disabled="disabled" @change="adapterDate => changeReadingDate(adapterDate)" />
              </v-col>
              <v-col cols="6">
                <v-input
                  :rules="rulesRequired()"
                  :value="historicForm.competence"
                >
                  <competence-month :competence="historicForm.competence" :listCompetencies="competencies"
                    :disabled="disabled" @change="competence => changeCompetence(competence)" width="110" />
                </v-input>
              </v-col>
              <v-col cols="4">
                <v-text-field v-model="historicForm.water_cubic_meters" label="Água" type="number" suffix="m³"
                  @input="updateConsumption()" :rules="rulesNumber(true, 0)" :disabled="disabled"
                  style="width: 100px;"></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field v-model="historicForm.sewer_cubic_meters" label="Esgoto" type="number" suffix="m³"
                  @input="updateConsumption()" :rules="rulesNumber(true, 0)" :disabled="disabled"
                  style="width: 100px;"></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field :value="fixed(historicForm.consumption_cubic_meters)" label="Consumo Total" type="number"
                  suffix="m³" :readonly="true" :disabled="disabled" style="width: 100px;"></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field v-model="historicForm.reference_economy" label="Referência" type="number" suffix="R$"
                  :rules="rulesNumber(true, 0)" @input="updateMonetaryConsumption()" :disabled="disabled"
                  style="width: 110px;"></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field v-model="historicForm.cost_consumption" label="Custo Total" type="number" suffix="R$"
                  :rules="rulesNumber(true, 0)" @input="updateMonetaryConsumption()" :disabled="disabled"
                  style="width: 110px;"></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field :value="fixed(historicForm.financial_economy)" label="Economia" suffix="R$" :readonly="true"
                  :disabled="disabled" style="width: 110px;"></v-text-field>
              </v-col>
              <v-col v-if="hasCurrentBaselineDriverConfig" cols="12">
                <v-switch
                  v-model="historicDriverEnabled"
                  label="Adicionar driver de referência"
                  dense
                  inset
                  :disabled="disabled"
                  @change="changeHistoricDriverEnabled"
                ></v-switch>
              </v-col>
              <template v-if="hasCurrentBaselineDriverConfig && historicDriverEnabled">
                <v-col cols="12">
                  <v-text-field
                    v-model="historicForm.driver_reference_value"
                    :label="currentBaselineDriverLabel"
                    :suffix="currentBaselineDriverUnitLabel"
                    type="number"
                    min="0.01"
                    outlined
                    dense
                    :disabled="disabled"
                  ></v-text-field>
                </v-col>
              </template>
              <v-col cols="12">
                <v-textarea v-model="historicForm.observation" label="Observação"></v-textarea>
              </v-col>
              <v-col cols="12">
                <InputFiles 
                  title="Adicionar PDF da Conta do Mês"
                  :fileTypes="['pdf']"
                  :showFile="historicForm.file_photo_account"
                  :required="false"
                  :disabled="disabled"
                  @change:file="handleFileChange" 
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialog = false">
            Cancelar
          </v-btn>

          <v-btn 
            color="green darken-1" 
            text 
            :loading="isSaving"
            :disabled="isSaving"
            @click="addHistoric(currentIndex)"
          >
            {{ confirmForm }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row justify="center">
      <v-dialog v-model="historicsServiceDialog" v-if="historicsServiceDialog" persistent max-width="1100px">
        <v-card>
          <v-card-title>
            <span class="text-h5"> Historicos Encontrados</span>
          </v-card-title>
          <v-card-text>
            <v-divider />
            <v-row v-if="captchaImg">
              <v-col cols="12">
                <v-card>
                  <v-img
                    :src="captchaImg"
                    max-height="300"
                    contain
                  ></v-img>
                </v-card>
              </v-col>
              <v-col cols="10">
                <v-text-field v-model="capatchaResponse"  label="CAPTCHA" :loading="loadingCaptcha"></v-text-field>
              </v-col>
              <v-col cols="2">
                <v-btn text @click="salveCaptcha" :loading="loadingCaptcha">
                  Enviar
                </v-btn>
              </v-col>
            </v-row>
            <v-row v-if="loadingSkeleton">
              <v-col v-for="n in 3" :key="n" cols="12" md="12">
                <skeleton-component style="height: 30px; border-radius: 15px"></skeleton-component>
              </v-col>
            </v-row>
            <div v-if="!loadingSkeleton" style="overflow: auto;">
              <tr v-if="historicResponse.length">
                <th v-for="(headers, key) in displayRecordHeadersHistoricsResponse" :key="key">
                  {{ headers.text }}
                </th>
              </tr>
              <tr v-for="(historic, key) in historicResponse" :key="key">
                <td style="display: flex">
                  <div
                    style="display: flex;justify-content: center;align-items: center;margin-right: 10px;width: 80px;">
                    <v-chip :color="getColorMonth(historic)">
                      {{ getTagMonth(historic) }}
                    </v-chip>
                  </div>
                  <div style="width: 85px;">
                    <v-text-field :value="formatDate(`${historic.month}-${historic.day}`, '<DD>/<MM>/<YYYY>')"
                      label="Data" type="text" single-line autofocus readonly></v-text-field>
                  </div>
                </td>

                <td>
                  <div style="width: 60px;">
                    <v-text-field v-model="historic.competence" label="Data" type="text" single-line autofocus
                      readonly></v-text-field>
                  </div>
                </td>

                <td>
                  <v-text-field v-model="historic.water_cubic_meters" label="Água" suffix="m³" single-line
                    style="width: 100px;" readonly></v-text-field>
                </td>

                <td>
                  <v-text-field v-model="historic.sewer_cubic_meters" label="Esgoto" suffix="m³" single-line
                    style="width: 100px;" readonly></v-text-field>
                </td>

                <td>
                  <v-text-field v-model="historic.consumption_cubic_meters" label="Consumo Total" suffix="m³"
                    single-line style="width: 100px;" readonly></v-text-field>
                </td>

                <td>
                  <v-text-field v-model="historic.cost_consumption" label="Custo Total" prefix="R$" single-line
                    style="width: 100px;" readonly></v-text-field>
                </td>

                <td>
                  <v-text-field v-model="historic.reference_economy" label="Referência" prefix="R$" single-line
                    style="width: 110px;" readonly></v-text-field>
                </td>

                <td>
                  <v-text-field v-model="historic.financial_economy" label="Referência" prefix="R$" single-line
                    style="width: 100px;" readonly></v-text-field>
                </td>
                <td v-if="hasCurrentBaselineConfig">
                  <v-text-field :value="formatHistoricDriverReference(historic)" label="Driver" single-line
                    style="width: 120px;" readonly></v-text-field>
                </td>
                <td>
                  <v-text-field v-model="historic.observation" label="Observação" prefix="Obs" single-line
                    style="width: 100px;" readonly></v-text-field>
                </td>
              </tr>
            </div>
            <v-divider />
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn :disabled="historicResponse.length === 0" color="blue darken-1" text
              @click="addHistoricResponseOnHistoricUnit()">
              Adicionar
            </v-btn>
            <v-btn color="blue darken-1" text @click="close()">
              Fechar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import ObjectValidator from '@/scripts/ObjectValidator';
import Utils from '@/scripts/Utils';
import Rules from "@/utils/Rules";

import CompetenceMonth from "@/pages/Units/Widgets/competence-month.vue";
import HistoricReadingDate from "@/pages/Units/Widgets/historic-reading-date.vue";
import InstallationDateDialog from "@/pages/Units/Widgets/installation-date-dialog.vue";
import SkeletonComponent from "@/components/Skeleton/Skeleton.vue";
import InputFiles from "@/components/Forms/Input/input-files.vue";
import { showInfoSnackBar, showSuccessSnackBar, showErrorSnackBar } from "@/utils/SnackBartHelper"
import TokenService from"@/services/firebase/Token/TokenService.js";
import UnitServiceServer from "@/services/server/UnitsService";
import ConsumptionService from "@/services/server/ConsumptionService.js";
import { showDeleteDialogAlert } from '@/utils/DialogAlertHelper';



import axios from "axios";
const CONSTANTS = {
  recordHeaders: [
    { text: "Data", value: "month", sortable: false },
    { text: "Competência", value: "competence" },
    { text: "Água", value: "water_cubic_meters" },
    { text: "Água FOZ", value: "fozTelemetry.water", sortable: false },
    { text: "Esgoto", value: "sewer_cubic_meters" },
    { text: "Esgoto FOZ", value: "fozTelemetry.sewer", sortable: false },
    { text: "Consumo Total", value: "consumption_cubic_meters" },
    { text: "Total FOZ", value: "fozTelemetry.total", sortable: false },
    { text: "Custo Total", value: "cost_consumption" },
    { text: "Referência", value: "reference_economy" },
    { text: "Economia", value: "financial_economy" },
    { text: "Driver", value: "driver_reference_value", sortable: false },
    { text: "Observação", value: "observation" },
    { text: "Arquivo", value: "file", sortable: false },
    { text: "Ações", value: "actions", sortable: false },
  ],
  recordHeadersHistoricsResponse: [
    { text: "Data", value: "month", sortable: false },
    { text: "Competência", value: "competence" },
    { text: "Água", value: "water_cubic_meters" },
    { text: "Esgoto", value: "sewer_cubic_meters" },
    { text: "Consumo Total", value: "consumption_cubic_meters" },
    { text: "Custo Total", value: "cost_consumption" },
    { text: "Referência", value: "reference_economy" },
    { text: "Economia", value: "financial_economy" },
    { text: "Driver", value: "driver_reference_value", sortable: false },
    { text: "Observação", value: "observation" },

  ],
}

/**
 * Campo de leitura da data do histórico que tem como objetivo manter a estrutura
 * do histórico para não quebrar a compatibiidade
 * 
 * @params {Array} historics: é uma lista de históricos
 * @params {String} dataMediaHistorico: é mês de instalação foz no formato '<YYYY>-<MM>'
*/
export default {

  components: {
    HistoricReadingDate,
    CompetenceMonth,
    InstallationDateDialog,
    SkeletonComponent,
    InputFiles,
  },

  props: {
    historicos: {
      type: Array,
      required: false,
      default: () => [],
    },
    unit: {
      default: () => { },
    },
    dataMediaHistorico: {
      type: String,
      required: false,
      default: null,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: true,
    },
    baselineConfig: {
      type: Object,
      required: false,
      default: null,
    },
    saveInstallationDate: {
      type: Function,
      required: false,
      default: null,
    },
  },

  data: () => ({
    ...CONSTANTS,
    captchaImg: '',
    capatchaResponse: '',
    listHistorics: [],
    instalattionDate: null,
    observation: "",
    action: 'signup',
    currentIndex: null,
    titleForm: '',
    confirmForm: '',
    historicForm: ObjectValidator.create('historico'),
    competencies: [],
    dialog: false,
    loadingCaptcha: false,
    historicResponse: [],
    historicsServiceDialog: false,
    loadingSkeleton: false,
    loadingIndex: null,
    loadingId: null,
    isSaving: false,
    isLoading: false,
    isSavingInstallationDate: false,
    fozConsumptionByMonth: {},
    fozConsumptionLoading: false,
    fozConsumptionRequestKey: null,
    historicTableOptions: {
      page: 1,
      itemsPerPage: 6,
    },
    historicDriverEnabled: false,
    valid: true,
  }),

  computed: {
    hasCurrentBaselineConfig() {
      return Boolean(this.baselineConfig && Object.keys(this.baselineConfig).length)
    },
    currentBaselineDriver() {
      return this.baselineConfig?.driver || null
    },
    hasCurrentBaselineDriverConfig() {
      return Boolean(this.currentBaselineDriver?.isEnabled)
    },
    displayRecordHeaders() {
      return this.getRecordHeadersByDriverConfig(this.recordHeaders)
    },
    displayRecordHeadersHistoricsResponse() {
      return this.getRecordHeadersByDriverConfig(this.recordHeadersHistoricsResponse)
    },
    listHistoricsWithFozTelemetry() {
      return this.listHistorics.map((historic) => {
        const readingDateReference = this.getHistoricReadingDateReference(historic)
        const fozTelemetry = this.fozConsumptionByMonth[readingDateReference] || {
          hasData: false,
          water: null,
          sewer: null,
          total: null,
        }

        return {
          ...historic,
          fozTelemetry,
        }
      })
    },
    currentBaselineDriverLabel() {
      return this.currentBaselineDriver?.driverLabel || "Valor de referência do driver"
    },
    currentBaselineDriverUnitLabel() {
      return this.currentBaselineDriver?.driverUnitLabel || ""
    },
    getInstalattionDate() {
      if (!this.instalattionDate) return "--/--";
      return Utils.formatMonthDate(this.instalattionDate, '<MM> de <YYYY>', true)
    },
    getTotalEconomy() {
      if (this.historicos.length) return Utils.formatCurrency(
            this.historicos
              .filter(historic => new Date(historic.month).getTime() >= new Date(this.instalattionDate).getTime() && historic.financial_economy > 0)
              .reduce((a, b) => a + b.financial_economy, 0)
              .toFixed(2)
          );
      return 0
    },
    getTotalEconomyM3() {
      if (this.historicos.length && this.getAverageBeforeFoz) {
        const consumptions = this.historicos.map((historic) => parseFloat(this.getAverageBeforeFoz) - parseFloat(historic.consumption_cubic_meters) > 0 ? parseFloat(this.getAverageBeforeFoz) - parseFloat(historic.consumption_cubic_meters) : 0)
        return consumptions.reduce((acc, current) => acc + current, 0).toFixed(2)
      }
      return 0
    },
    getTotalReference() {
      if (this.historicos.length) return this.historicos.reduce((a, b) => a + b.reference_economy, 0).toFixed(2)
      return 0
    },
    getLastReference() {
      if (this.historicos.length) {
        let teste = this.historicos.sort((a, b) => {
          return new Date(a.day + "-" + a.month).getTime() > new Date(b.day + "-" + b.month).getTime() ? -1 : new Date(a.day + "-" + a.month).getTime() < new Date(b.day + "-" + b.month).getTime() ? 1 : 0;
        })

        return Utils.formatCurrency(teste[0].reference_economy)
      }
      return 0
    },
    getAverageBeforeFoz() {
      if (this.historicos.length && this.instalattionDate) {
        let avaregeBefore = []
        this.historicos.forEach((historic) => {
          if (new Date(historic.month).getTime() < new Date(this.instalattionDate).getTime()) {
            avaregeBefore.push(historic.consumption_cubic_meters)
          }
        })
        return avaregeBefore.length ? (avaregeBefore.reduce((a, b) => a + b) / avaregeBefore.length).toFixed(2) : 0
      }
      return 0
    },
    getAverageAfterFoz() {
      if (this.historicos.length && this.instalattionDate) {
        let avaregeBefore = []
        this.historicos.forEach((historic) => {
          if (new Date(historic.month).getTime() >= new Date(this.instalattionDate).getTime()) {
            avaregeBefore.push(historic.consumption_cubic_meters)
          }
        })

        return avaregeBefore.length > 0 ?
          (avaregeBefore.reduce((a, b) => a + b, 0) / avaregeBefore.length).toFixed(2)
          :
          0
      }
      return 0
    },
    
  },

  methods: {
    close(){
      this.historicsServiceDialog = false
      this.capatchaResponse = ''
      this.captchaImg = ''
    },
    fixed(number) {
      if (number === "" || number === null || number === undefined) return ""
      return number.toFixed(2)
    },
    formatDate(dateInput, format = '<DD>/<MM>/<YYYY>') {
      if (!dateInput) return null;
      return Utils.formatDate(dateInput, format)
    },
    formatMonthDate(dateInput, format = '<MM>/<YY>', isFullMonthName = false) {
      if (!dateInput) return null;
      return Utils.formatMonthDate(dateInput, format, isFullMonthName)
    },
    formatNumber(value, fractionDigits = 2) {
      return Utils.formatNumber(value, fractionDigits)
    },
    formatCurrency(value, fractionDigits = 2) {
      return Utils.formatCurrency(value, fractionDigits)
    },
    formatHistoricReadingDate(historic = {}) {
      return this.formatDate(`${historic.month}-${historic.day}`, '<DD>/<MM>/<YYYY>')
    },
    formatHistoricCompetence(historic = {}) {
      return this.formatMonthDate(historic.competence, '<MM>/<YY>')
    },
    formatFozTelemetryValue(fozTelemetry = {}, field) {
      if (!fozTelemetry.hasData) return "-"
      return this.formatNumber(fozTelemetry[field])
    },
    isFozTelemetryLoading(fozTelemetry = {}) {
      return this.fozConsumptionLoading && !fozTelemetry.hasData
    },
    getFozTotalVariationPercentage(historic = {}) {
      const compesaTotal = Number(historic.consumption_cubic_meters || 0)
      const fozTotal = Number(historic.fozTelemetry?.total || 0)
      if (!historic.fozTelemetry?.hasData || !Number.isFinite(compesaTotal) || !Number.isFinite(fozTotal) || compesaTotal <= 0) {
        return null
      }
      return Math.abs(fozTotal - compesaTotal) / compesaTotal * 100
    },
    formatFozTotalVariationPercentage(historic = {}) {
      const variationPercentage = this.getFozTotalVariationPercentage(historic)
      if (variationPercentage === null) return "-"
      return `${this.formatNumber(variationPercentage)}%`
    },
    getFozTotalVariationBadgeClass(historic = {}) {
      const variationPercentage = this.getFozTotalVariationPercentage(historic)
      if (variationPercentage === null) return 'foz-total-alert-badge'
      if (variationPercentage <= 10) return 'foz-total-alert-badge foz-total-alert-badge--low'
      if (variationPercentage <= 20) return 'foz-total-alert-badge foz-total-alert-badge--medium'
      return 'foz-total-alert-badge foz-total-alert-badge--high'
    },
    shouldShowFozTotalAlert(historic = {}) {
      const variationPercentage = this.getFozTotalVariationPercentage(historic)
      return Boolean(
        variationPercentage !== null &&
        variationPercentage > 0
      )
    },
    getUnitId() {
      return this.unit?.id || this.unit?.doc_id || null
    },
    normalizeDateReference(value) {
      if (!value) return null
      if (value instanceof Date && !Number.isNaN(value.getTime())) {
        const year = value.getFullYear()
        const month = String(value.getMonth() + 1).padStart(2, '0')
        const day = String(value.getDate()).padStart(2, '0')
        return `${year}-${month}-${day}`
      }

      const valueString = String(value)
      const isoMatch = valueString.match(/^(\d{4})-(\d{1,2})(?:-(\d{1,2}))?/)
      if (isoMatch) {
        return `${isoMatch[1]}-${String(isoMatch[2]).padStart(2, '0')}-${String(isoMatch[3] || '01').padStart(2, '0')}`
      }

      const brMatch = valueString.match(/^(\d{1,2})\/(\d{1,2})\/(\d{2,4})/)
      if (brMatch) {
        const year = brMatch[3].length === 2 ? `20${brMatch[3]}` : brMatch[3]
        return `${year}-${String(brMatch[2]).padStart(2, '0')}-${String(brMatch[1]).padStart(2, '0')}`
      }

      const parsedDate = new Date(value)
      if (!Number.isNaN(parsedDate.getTime())) {
        const year = parsedDate.getFullYear()
        const month = String(parsedDate.getMonth() + 1).padStart(2, '0')
        const day = String(parsedDate.getDate()).padStart(2, '0')
        return `${year}-${month}-${day}`
      }

      return null
    },
    getHistoricReadingDateReference(historic = {}) {
      const monthReference = String(historic.month || '').match(/^(\d{4})-(\d{1,2})/)
      const dayReference = historic.day !== null && historic.day !== undefined ? String(historic.day).padStart(2, '0') : null
      if (!monthReference || !dayReference) return null
      return `${monthReference[1]}-${String(monthReference[2]).padStart(2, '0')}-${dayReference}`
    },
    getOrderedHistoricReadingDates() {
      return this.listHistorics
        .map((historic) => ({
          historic,
          readingDate: this.getHistoricReadingDateReference(historic),
        }))
        .filter(({ readingDate }) => Boolean(readingDate))
        .sort((current, next) => current.readingDate.localeCompare(next.readingDate))
    },
    buildStartOfDayISOString(dateReference) {
      const normalizedDate = this.normalizeDateReference(dateReference)
      if (!normalizedDate) return null
      return `${normalizedDate}T03:00:00.000Z`
    },
    buildEndOfReadingPeriodISOString(dateReference) {
      const normalizedDate = this.normalizeDateReference(dateReference)
      if (!normalizedDate) return null
      const date = new Date(`${normalizedDate}T03:00:00.000Z`)
      date.setUTCDate(date.getUTCDate() + 1)
      return `${date.toISOString().slice(0, 10)}T02:59:59.000Z`
    },
    normalizeFozTelemetryValue(value) {
      const numericValue = Number(value || 0)
      return Number.isFinite(numericValue) ? numericValue / 1000 : 0
    },
    getHistoricRowKey(historic = {}) {
      return historic.id || historic.doc_id || historic.id_doc || `${historic.month || 'month'}-${historic.day || 'day'}-${historic.competence || 'competence'}`
    },
    getNestedValue(source = {}, path = '') {
      return path.split('.').reduce((value, key) => value?.[key], source)
    },
    getSortValue(historic = {}, sortField = '') {
      if (sortField === 'month') return this.getHistoricReadingDateReference(historic)
      return this.getNestedValue(historic, sortField)
    },
    compareHistoricSortValues(currentValue, nextValue) {
      const currentIsEmpty = currentValue === null || currentValue === undefined || currentValue === ''
      const nextIsEmpty = nextValue === null || nextValue === undefined || nextValue === ''
      if (currentIsEmpty && nextIsEmpty) return 0
      if (currentIsEmpty) return 1
      if (nextIsEmpty) return -1

      const currentNumber = Number(currentValue)
      const nextNumber = Number(nextValue)
      if (Number.isFinite(currentNumber) && Number.isFinite(nextNumber)) {
        return currentNumber - nextNumber
      }

      return String(currentValue).localeCompare(String(nextValue), 'pt-BR', {
        numeric: true,
        sensitivity: 'base',
      })
    },
    sortHistoricsForTable(items = [], sortBy = [], sortDesc = []) {
      const sortFields = Array.isArray(sortBy) ? sortBy : [sortBy]
      const sortDirections = Array.isArray(sortDesc) ? sortDesc : [sortDesc]
      const activeSortFields = sortFields.filter(Boolean)
      const sortedItems = [...items]

      if (!activeSortFields.length) return sortedItems

      return sortedItems.sort((current, next) => {
        for (let index = 0; index < activeSortFields.length; index++) {
          const sortField = activeSortFields[index]
          const currentValue = this.getSortValue(current, sortField)
          const nextValue = this.getSortValue(next, sortField)
          const comparison = this.compareHistoricSortValues(currentValue, nextValue)

          if (comparison !== 0) return sortDirections[index] ? -comparison : comparison
        }

        return 0
      })
    },
    getSortedHistoricsForCurrentTable() {
      const { sortBy = [], sortDesc = [] } = this.historicTableOptions || {}
      return this.sortHistoricsForTable(this.listHistoricsWithFozTelemetry, sortBy, sortDesc)
    },
    getVisibleHistoricsForCurrentPage() {
      const { page = 1, itemsPerPage = 6 } = this.historicTableOptions || {}
      const sortedHistorics = this.getSortedHistoricsForCurrentTable()
      if (itemsPerPage === -1) return sortedHistorics

      const startIndex = (page - 1) * itemsPerPage
      return sortedHistorics.slice(startIndex, startIndex + itemsPerPage)
    },
    resetFozConsumptionCache() {
      this.fozConsumptionByMonth = {}
      this.fozConsumptionRequestKey = null
      this.fozConsumptionLoading = false
    },
    getFozConsumptionPeriods(targetHistorics = this.getVisibleHistoricsForCurrentPage()) {
      const installationDate = this.normalizeDateReference(this.instalattionDate)
      const orderedHistorics = this.getOrderedHistoricReadingDates()
      const targetReadingDates = new Set(
        targetHistorics
          .map((historic) => this.getHistoricReadingDateReference(historic))
          .filter(Boolean)
      )

      return orderedHistorics.reduce((periods, current, index) => {
        const previous = orderedHistorics[index - 1]
        if (!previous || !current.readingDate || !installationDate) return periods
        if (!targetReadingDates.has(current.readingDate)) return periods
        if (current.readingDate <= installationDate) return periods

        const startDate = previous.readingDate < installationDate ? installationDate : previous.readingDate
        if (startDate >= current.readingDate) return periods

        periods.push({
          key: current.readingDate,
          startReference: startDate,
          endReference: current.readingDate,
          start_date: this.buildStartOfDayISOString(startDate),
          end_date: this.buildEndOfReadingPeriodISOString(current.readingDate),
        })

        return periods
      }, [])
    },
    getFozConsumptionRequestRange(periods = []) {
      const startReference = periods.reduce((minimumDate, period) => {
        if (!period.startReference) return minimumDate
        return !minimumDate || period.startReference < minimumDate ? period.startReference : minimumDate
      }, null)
      const endReference = periods.reduce((maximumDate, period) => {
        if (!period.endReference) return maximumDate
        return !maximumDate || period.endReference > maximumDate ? period.endReference : maximumDate
      }, null)

      return {
        start_date: this.buildStartOfDayISOString(startReference),
        end_date: this.buildEndOfReadingPeriodISOString(endReference),
      }
    },
    mapFozConsumptionDailyTotals(periods = [], consumptions = []) {
      return periods.reduce((accumulator, period) => {
        const totals = consumptions.reduce((periodTotal, consumption) => {
          const consumptionDate = this.normalizeDateReference(consumption?.time)
          if (!consumptionDate || consumptionDate < period.startReference || consumptionDate > period.endReference) {
            return periodTotal
          }

          periodTotal.hasData = true
          periodTotal.water += Number(consumption?.valueWater || 0)
          periodTotal.sewer += Number(consumption?.valueSewer || 0)
          return periodTotal
        }, { hasData: false, water: 0, sewer: 0 })

        accumulator[period.key] = {
          hasData: totals.hasData,
          water: this.normalizeFozTelemetryValue(totals.water),
          sewer: this.normalizeFozTelemetryValue(totals.sewer),
          total: this.normalizeFozTelemetryValue(totals.water + totals.sewer),
        }

        return accumulator
      }, {})
    },
    async loadFozConsumptionByHistoricRange() {
      const unitId = this.getUnitId()
      const periods = this.getFozConsumptionPeriods()
      const validPeriods = periods.filter(({ start_date, end_date }) => start_date && end_date)
      const pendingPeriods = validPeriods.filter(({ key }) => !this.fozConsumptionByMonth[key])

      if (!unitId || !validPeriods.length) {
        this.fozConsumptionRequestKey = null
        this.fozConsumptionLoading = false
        return
      }

      if (!pendingPeriods.length) {
        this.fozConsumptionRequestKey = null
        this.fozConsumptionLoading = false
        return
      }

      const requestRange = this.getFozConsumptionRequestRange(pendingPeriods)
      const periodKey = pendingPeriods.map(({ key, start_date, end_date }) => `${key}:${start_date}:${end_date}`).join('|')
      const requestKey = `${unitId}|${requestRange.start_date}:${requestRange.end_date}|${periodKey}`
      if (this.fozConsumptionRequestKey === requestKey) return

      this.fozConsumptionRequestKey = requestKey
      this.fozConsumptionLoading = true

      try {
        const response = await ConsumptionService.consumptionByUnitByTariff({
          start_date: requestRange.start_date,
          end_date: requestRange.end_date,
          mode: "day",
          unit_measurement: "m3",
          unit_id: unitId,
          includeInvoicedOnly: true,
        })

        if (this.fozConsumptionRequestKey !== requestKey) return

        const fozConsumptionByPendingPeriod = this.mapFozConsumptionDailyTotals(
          pendingPeriods,
          response?.data?.data?.consumptions || []
        )
        this.fozConsumptionByMonth = {
          ...this.fozConsumptionByMonth,
          ...fozConsumptionByPendingPeriod,
        }
      } catch (error) {
        if (this.fozConsumptionRequestKey === requestKey) {
          this.fozConsumptionLoading = false
          this.fozConsumptionRequestKey = null
        }
        console.error("Erro ao buscar telemetria FOZ para o historico:", error)
      } finally {
        if (this.fozConsumptionRequestKey === requestKey) this.fozConsumptionLoading = false
      }
    },
    getRecordHeadersByDriverConfig(headers = []) {
      if (this.hasCurrentBaselineConfig) return headers
      return headers.filter(({ value }) => value !== "driver_reference_value")
    },
    hasHistoricDriverData(historic = {}) {
      return historic.driver_reference_value !== null && historic.driver_reference_value !== undefined && historic.driver_reference_value !== ""
    },
    clearHistoricDriverFields() {
      this.historicForm.driver_reference_value = null
    },
    sanitizeHistoricDriverFields(historic = {}) {
      delete historic.driver_type
      delete historic.driver_label
      delete historic.driver_unit_label
      return historic
    },
    changeHistoricDriverEnabled(value) {
      if (!value) this.clearHistoricDriverFields()
    },
    formatHistoricDriverReference(historic = {}) {
      const value = historic.driver_reference_value
      if (value === null || value === undefined || value === "") return "-"

      const numericValue = Number(value)
      const formattedValue = Number.isFinite(numericValue)
        ? this.formatNumber(numericValue)
        : value
      const unitLabel = this.currentBaselineDriverUnitLabel
      return unitLabel ? `${formattedValue} ${unitLabel}` : formattedValue
    },

    getChangePayload() {
      const historics = this.listHistorics
      function getLastReadingDate() {
        let dates = historics.map(
          (historic) => {
            let day = historic['day']
            let month = historic['month']
            let date_format = `${month}-${day}T03:00:00Z`
            return new Date(date_format);
          }
        )
        if (dates.length) return dates.sort((datePrevious, dateNext) => datePrevious < dateNext ? 1 : -1)[0]
        return null
      }
      
      // Preservar arquivos File antes de fazer cópia
      const historicsWithFiles = this.listHistorics.map(historic => {
        const copied = Utils.copyObject(historic);
        // Restaurar arquivo File e flag de delete após cópia
        if (historic.file_photo_account) {
          copied.file_photo_account = historic.file_photo_account;
        }
        if (historic._shouldDeleteFile !== undefined) {
          copied._shouldDeleteFile = historic._shouldDeleteFile;
        }
        return copied;
      });
      return {
        historicos: historicsWithFiles,
        dataMediaHistorico: this.instalattionDate,
        averageBeforeFoz: this.getAverageBeforeFoz,
        lastReadingDate: getLastReadingDate(),
      }
    },

    emitChange() {
      this.$emit('change', this.getChangePayload())
    },
    async saveInstalattionDate(date) {
      const previousDate = this.instalattionDate
      this.instalattionDate = date
      const payload = this.getChangePayload()

      if (!this.saveInstallationDate) {
        this.emitChange()
        return
      }

      this.isSavingInstallationDate = true
      try {
        await this.saveInstallationDate(payload)
        this.emitChange()
        showSuccessSnackBar("Data de instalacao salva com sucesso!")
      } catch (error) {
        this.instalattionDate = previousDate
        showErrorSnackBar("Erro ao salvar a data de instalacao.")
        console.error(error)
      } finally {
        this.isSavingInstallationDate = false
      }
    },

    newHistoricForm() {
      this.titleForm = "Cadastrar um histórico";
      this.confirmForm = "Inserir"
      this.historicForm = ObjectValidator.create('historico')
      this.historicDriverEnabled = false
      // Limpar campos de arquivo
      this.historicForm.file_photo_account = null;
      this.historicForm.path_file_photo_account = null;
      this.historicForm.file_photo_account_name = null;
      this.historicForm._shouldDeleteFile = false;
      this.currentIndex = null
      this.loadCompetencies();
      this.dialog = true;
      this.$nextTick(() => this.$refs.form && this.$refs.form.resetValidation());
    },

    async editHistoricForm(month_ref) {
      let index = this.getHistoricIndexByMonth(month_ref)
      this.loadingId = month_ref;
      this.titleForm = "Editar um histórico";
      this.confirmForm = "Salvar"

      const originalHistoric = this.listHistorics[index];
      
      // Preservar arquivo File se existir antes de fazer cópia
      const preservedFile = originalHistoric.file_photo_account;
      const preservedShouldDelete = originalHistoric._shouldDeleteFile;
      
      this.historicForm = Utils.copyObject(originalHistoric);
      this.historicDriverEnabled = this.hasCurrentBaselineDriverConfig && this.hasHistoricDriverData(this.historicForm)
      
      // Restaurar arquivo File após cópia
      if (preservedFile) {
        this.historicForm.file_photo_account = preservedFile;
      }
      if (preservedShouldDelete !== undefined) {
        this.historicForm._shouldDeleteFile = preservedShouldDelete;
      }

      // Se existe arquivo anexado, fazer download para exibir no InputFiles
      if (this.historicForm.path_file_photo_account && !this.historicForm.file_photo_account) {
        try {
          const unitId = this.unit.id || this.unit.doc_id;
          const urlResponse = await UnitServiceServer.getHistoricFileDownloadURL(unitId, this.historicForm.path_file_photo_account);
          const downloadURL = urlResponse && urlResponse.data ? urlResponse.data.data : null;
          if (!downloadURL) throw new Error("URL do arquivo nao retornada pelo servidor.");
          const response = await fetch(downloadURL);
          const blob = await response.blob();
          
          // Converter Blob para File para o InputFiles exibir corretamente
          // Garantir que o tipo MIME seja 'application/pdf' e a extensão seja .pdf
          const fileName = this.historicForm.file_photo_account_name || 'conta.pdf';
          const fileNameWithExt = fileName.toLowerCase().endsWith('.pdf') ? fileName : `${fileName}.pdf`;
          const file = new File([blob], fileNameWithExt, { 
            type: 'application/pdf',
            lastModified: Date.now()
          });
          
          this.historicForm.file_photo_account = file;
        } catch (error) {
          console.error("Erro ao carregar arquivo para edição:", error);
          // Continua sem o arquivo se der erro
        }
      }

      this.currentIndex = index
      this.loadCompetencies(this.historicForm.competence)
      this.loadingId = null;
      this.dialog = true;
      this.$nextTick(() => this.$refs.form && this.$refs.form.resetValidation());
    },

    callDialogAlert(month_ref){
      showDeleteDialogAlert("Você tem certeza que deseja deletar este histórico?", () => this.removeHistoric(month_ref))
    },

    async removeHistoric(month_ref) {
      this.loadingId = month_ref;
      let index = this.getHistoricIndexByMonth(month_ref)
      if (index < 0) throw new Error(`Não foi possível deletar o histórico por não encontrar o mês '${month_ref}'`)
      let _listHistorics = Utils.copyObject(this.listHistorics)
      _listHistorics.splice(index, 1)
      this.listHistorics = _listHistorics
      this.loadCompetencies()
      await this.callUpdateHistorics(this.unit.id || this.unit.doc_id, _listHistorics, "remove")
      
      // Limpar flags temporárias após sucesso
      this.listHistorics.forEach(h => {
        h._shouldDeleteFile = false;
        h.file_photo_account = null;
      });

      this.emitChange();
      this.loadingId = null;
    },
    getHistoricIndexByMonth(month_ref) {
      let historic_index = this.listHistorics.findIndex(
        (h) => {
          return h.month === month_ref
        }
      )
      return historic_index
    },

    async addHistoric(index = null) {
      if (!this.$refs.form.validate() || !this.historicForm.competence) {
        return;
      }
      this.isSaving = true;
      if (!this.hasCurrentBaselineDriverConfig || !this.historicDriverEnabled) this.clearHistoricDriverFields()
      // Preservar o arquivo File antes de fazer cópia (JSON.stringify não preserva File objects)
      const fileToPreserve = this.historicForm.file_photo_account;
      const shouldDeleteFile = this.historicForm._shouldDeleteFile;
      
      let _historic = this.sanitizeHistoricDriverFields(Utils.copyObject(this.historicForm))
      
      // Restaurar o arquivo File após a cópia
      if (fileToPreserve) {
        _historic.file_photo_account = fileToPreserve;
      }
      if (shouldDeleteFile !== undefined) {
        _historic._shouldDeleteFile = shouldDeleteFile;
      }

      // Impedir duplicidade de mês (YYYY-MM)
      const monthRef = _historic.month;
      const duplicateIndex = this.getHistoricIndexByMonth(monthRef);
      if (duplicateIndex !== -1 && duplicateIndex !== index) {
        showErrorSnackBar(`Já existe um histórico vinculado a esse mês: ${Utils.formatMonthDate(monthRef, '<MM>/<YYYY>')} !`);
        this.isSaving = false;
        return;
      }
      
      let _listHistorics = Utils.copyObject(this.listHistorics)
      
      // Preservar arquivos File em todos os históricos da lista
      _listHistorics = _listHistorics.map(h => {
        const originalHistoric = this.listHistorics.find(orig => orig.month === h.month && orig.day === h.day);
        if (originalHistoric && originalHistoric.file_photo_account) {
          h.file_photo_account = originalHistoric.file_photo_account;
        }
        if (originalHistoric && originalHistoric._shouldDeleteFile !== undefined) {
          h._shouldDeleteFile = originalHistoric._shouldDeleteFile;
        }
        return h;
      });
      
      if (index === null) { // Cadastro
        _listHistorics.unshift(_historic);
        this.listHistorics = _listHistorics;
        await this.callUpdateHistorics(this.unit.id || this.unit.doc_id, _listHistorics, "add", 0)
      } else { // Edição
        _listHistorics[index] = _historic;
        this.listHistorics = _listHistorics;
        await this.callUpdateHistorics(this.unit.id || this.unit.doc_id, _listHistorics, "edit", index)
      }
      this.isSaving = false;
      this.dialog = false;

      // Limpar objetos File e flags de exclusão do estado local após salvar com sucesso
      // Isso evita re-uploads desnecessários e herança de caminhos de arquivos
      this.listHistorics.forEach(h => {
        h.file_photo_account = null;
        h._shouldDeleteFile = false;
      });

      this.emitChange();
    },

    handleFilePath(resultFilePath, index) {
      if (resultFilePath && index !== null && this.listHistorics[index]) {
        this.listHistorics[index].path_file_photo_account = resultFilePath;
        // Limpar o objeto File localmente para evitar que seja re-enviado em futuras operações
        this.listHistorics[index].file_photo_account = null;
      }
    },


    async callUpdateHistorics(unitId, historicsList, context, index = null) {
      const lastGoodList = [...this.listHistorics]; // Backup para rollback
      try {
        const sanitizedHistoricsList = historicsList.map((historic) => this.sanitizeHistoricDriverFields(historic))
        const response = await UnitServiceServer.updateSubCollectionHistorics(unitId, sanitizedHistoricsList)
        const resultFilePath = response && response.data ? response.data.data : null;
        
        // Se o serviço retornar false, algo deu errado no backend (mesmo sem throw)
        if (resultFilePath === false) throw new Error("Erro no serviço de persistência");

        this.handleFilePath(resultFilePath, index)
        
        if (context === "add") {
          showSuccessSnackBar("Histórico adicionado com sucesso!")
        } else if (context === "edit") {
          showSuccessSnackBar("Histórico atualizado com sucesso!")
        } else if (context === "remove") {
          showSuccessSnackBar("Histórico removido com sucesso!")
        }
      } catch (error){
        console.error("Erro ao atualizar histórico:", error);
        showErrorSnackBar("Erro ao salvar no banco. Revertendo alteração...");
        // Rollback do estado local
        this.listHistorics = lastGoodList;
      }
    },

    getColorMonth(historico) {
      if (!this.instalattionDate) return "grey";
      let dateMonth = Utils.instanceDate(historico.month)
      let _instalattionDate = Utils.instanceDate(this.instalattionDate)
      if (dateMonth < _instalattionDate) return "red"
      else return "green"
    },
    getTagMonth(historico) {
      if (!this.instalattionDate) return "--";
      let dateMonth = Utils.instanceDate(historico.month)
      let _instalattionDate = Utils.instanceDate(this.instalattionDate)
      if (dateMonth < _instalattionDate) return "Antes";
      else return "Depois";
    },

    async changeReadingDate(adapterDate) {
      this.historicForm.month = adapterDate.month
      this.historicForm.day = adapterDate.day
    },

    loadCompetencies(date_remove = null) {
      this.competencies = this.listHistorics.map((h) => h.competence).filter((c) => c === null ? false : date_remove !== c)
    },
    async changeCompetence(competence) {
      if (this.competencies.includes(competence)) {
        showErrorSnackBar("Competência já selecionada")
        return;
      }
      this.historicForm.competence = competence
    },

    updateConsumption() {
      let total = 0;
      let water_cubic_meters = this.historicForm.water_cubic_meters !== "" && this.historicForm.water_cubic_meters !== null && this.historicForm.water_cubic_meters !== undefined && !isNaN(this.historicForm.water_cubic_meters) ? parseFloat(this.historicForm.water_cubic_meters) : 0
      let sewer_cubic_meters = this.historicForm.sewer_cubic_meters !== "" && this.historicForm.sewer_cubic_meters !== null && this.historicForm.sewer_cubic_meters !== undefined && !isNaN(this.historicForm.sewer_cubic_meters) ? parseFloat(this.historicForm.sewer_cubic_meters) : 0
      total = water_cubic_meters + sewer_cubic_meters
      this.historicForm.consumption_cubic_meters = total;
    },

    updateMonetaryConsumption() {
      let total = 0;
      let reference_economy = this.historicForm.reference_economy !== "" && this.historicForm.reference_economy !== null && this.historicForm.reference_economy !== undefined && !isNaN(this.historicForm.reference_economy) ? parseFloat(this.historicForm.reference_economy) : 0
      let cost_consumption = this.historicForm.cost_consumption !== "" && this.historicForm.cost_consumption !== null && this.historicForm.cost_consumption !== undefined && !isNaN(this.historicForm.cost_consumption) ? parseFloat(this.historicForm.cost_consumption) : 0
      total = reference_economy - cost_consumption
      this.historicForm.financial_economy = total
    },

    rulesNumber(isRequired = false, min = 1, max = null) {
      return Rules.number(isRequired, min, max);
    },
    rulesRequired() {
      let optionals = [];
      optionals.push(value => !!value || 'Requerido');
      return optionals
    },
    async salveCaptcha() {
      await TokenService.updateCaptcha(this.capatchaResponse.toUpperCase())
      this.loadingCaptcha = true
      // this.close()    
      showSuccessSnackBar("Captcha salvo, tente buscar as contas novamente!")
    },
    async getAccountsCompesa() {
      this.historicResponse = []
      try {
        if (!this.unit.dataMediaHistorico) throw "A unidade precisa ter uma data de Instalação definida!"
        this.historicsServiceDialog = true
        this.loadingSkeleton = true
        let msg = ""
        //   `http://localhost:3000/v1/compesa/${this.unit.id}`)
        // `https://simple-express-cu622gxaua-uc.a.run.app/v1/compesa/${this.unit.id}`)
  

        this.loadingSkeleton = true;

        fetch(`https://simple-express-cu622gxaua-uc.a.run.app/v1/compesa/${this.unit.id}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then(async (response) => {
          const reader = response.body.getReader();
          const decoder = new TextDecoder('utf-8');

          let accumulatedChunks = '';

          while (true) {
            const { value, done } = await reader.read();
            if (done) break;

            accumulatedChunks += decoder.decode(value, { stream: true });

            // Tentar parsear JSON
            try {
              const data = JSON.parse(accumulatedChunks.trim());
              this.loadingCaptcha = false
              this.captchaImg = ''
              this.capatchaResponse = ''

              if (response.status === 203 || data.captchaImg) {
                this.captchaImg = data.captchaImg;
                this.historicResponse = [];
                this.loadingSkeleton = false;
                showInfoSnackBar(data.message);
              } else if (response.status === 200 || data.data) {
                this.historicResponse = data.data;
                const msg = data.message;
                if (msg !== "Sucesso na busca das contas!") {
                  this.historicsServiceDialog = false;
                  showInfoSnackBar(msg);
                }
                this.loadingSkeleton = false;
              }

              accumulatedChunks = '';
            } catch (error) {
              console.log("Aguardando mais chunks...");
            }
          }
        })
        .catch((err) => {
          console.error("Erro na requisição:", err);
          showInfoSnackBar("Erro na requisição ao servidor");
          this.loadingSkeleton = false;
        });


      } catch (err) {
        console.error(err)
        showInfoSnackBar(err)
      }

    },
    async addHistoricResponseOnHistoricUnit() {
      let teste = [...this.listHistorics, ...this.historicResponse]
      this.listHistorics = teste.sort((a, b) => {
        const aDate = new Date(this.formatDate(`${a.month}-${a.day}`, '<MM>/<DD>/<YYYY>')).getTime()
        const bDate = new Date(this.formatDate(`${b.month}-${b.day}`, '<MM>/<DD>/<YYYY>')).getTime()
        return aDate > bDate ? -1 : aDate < bDate ? 1 : 0;
      })

      this.callUpdateHistorics(this.unit.id || this.unit.doc_id, this.listHistorics, "add")
      this.emitChange();
      this.historicsServiceDialog = false
    },
    handleFileChange(file) {
      // Se o arquivo foi removido (null ou undefined)
      if (!file) {
        // Marcar que o arquivo antigo deve ser deletado
        this.historicForm._shouldDeleteFile = !!this.historicForm.path_file_photo_account;
        
        // Limpar os campos relacionados
        this.historicForm.file_photo_account = null;
        this.historicForm.path_file_photo_account = null;
        this.historicForm.file_photo_account_name = null;
      } else {
        // Arquivo novo foi adicionado
        this.historicForm.file_photo_account = file;
        
        // Se havia um arquivo antigo, marcar para deletar
        if (this.historicForm.path_file_photo_account) {
          this.historicForm._shouldDeleteFile = true;
        }
      }
    },
    async downloadFileFromList(historic) {
      if (!historic.path_file_photo_account) return;
      
      try {
        const unitId = this.unit.id || this.unit.doc_id;
        const response = await UnitServiceServer.getHistoricFileDownloadURL(unitId, historic.path_file_photo_account);
        const url = response && response.data ? response.data.data : null;
        if (!url) throw new Error("URL do arquivo nao retornada pelo servidor.");
        
        // Abrir em nova aba
        window.open(url, '_blank');
        
        showSuccessSnackBar("Abrindo arquivo...");
      } catch (error) {
        console.error("Erro ao baixar arquivo:", error);
        showErrorSnackBar("Erro ao baixar o arquivo da conta");
      }
    },
  },

  watch: {
    dataMediaHistorico: {
      immediate: true,
      handler: function (newValue) {
        this.instalattionDate = newValue
        this.resetFozConsumptionCache()
        this.loadFozConsumptionByHistoricRange()
      },
    },

    historicos: {
      immediate: true,
      handler: function (newValue) {
        this.listHistorics = newValue
      },
    },
    listHistorics: {
      handler: function () {
        this.resetFozConsumptionCache()
        this.loadFozConsumptionByHistoricRange()
      },
    },
    unit: {
      deep: true,
      handler: function () {
        this.resetFozConsumptionCache()
        this.loadFozConsumptionByHistoricRange()
      },
    },
    historicTableOptions: {
      deep: true,
      handler: function () {
        this.loadFozConsumptionByHistoricRange()
      },
    },
  },

  async created() {
  },

};
</script>

<style scoped>
.v-date-picker-table {
  height: auto !important;
}

.historic-table {
  border: 1px solid #e6eaf0;
  overflow: hidden;
}

.historic-table-toolbar {
  border-bottom: 1px solid #eef1f5;
}

.historic-date-cell {
  display: flex;
  align-items: center;
  min-width: 138px;
}

.historic-status-chip {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 62px;
  margin-right: 8px;
}

.historic-date-stack {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 72px;
}

.historic-date-stack span {
  color: #7b8490;
  font-size: 11px;
  font-weight: 600;
}

.historic-date-stack strong,
.historic-competence,
.historic-metric strong {
  color: #1f2933;
  font-size: 13px;
  font-weight: 650;
}

.historic-competence {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 50px;
  min-height: 28px;
  border: 1px solid #e1e6ed;
  border-radius: 8px;
  background-color: #f9fbfd;
}

.historic-metric {
  display: inline-flex;
  align-items: baseline;
  justify-content: flex-end;
  gap: 4px;
  min-width: 86px;
  min-height: 32px;
  padding: 6px 7px;
  border: 1px solid #e6ebf1;
  border-radius: 8px;
  background-color: #ffffff;
}

.historic-metric span {
  color: #6b7280;
  font-size: 11px;
  font-weight: 600;
}

.historic-metric-foz {
  border-color: #d7e7f3;
  background-color: #f6fbff;
}

.foz-metric-skeleton {
  display: inline-block;
  width: 58px;
  height: 14px;
  border-radius: 999px;
  background: linear-gradient(90deg, #dcebf5 0%, #f5fbff 50%, #dcebf5 100%);
  background-size: 180% 100%;
  animation: foz-skeleton-loading 1.1s ease-in-out infinite;
}

.historic-metric-total {
  min-width: 94px;
}

.historic-money {
  border-color: #e5e8ec;
  background-color: #fbfcfd;
}

.foz-total-cell {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  min-width: 120px;
}

.foz-total-alert-badge {
  min-width: 48px;
  height: 20px !important;
  justify-content: center;
  font-weight: 600;
  letter-spacing: 0;
  border-radius: 999px !important;
  padding: 0 6px !important;
}

.foz-total-alert-badge--low {
  border: 1px solid #9bd6ad !important;
  background-color: #e8f7ed !important;
  color: #1d6b35 !important;
}

.foz-total-alert-badge--medium {
  border: 1px solid #f0c35a !important;
  background-color: #fff4d6 !important;
  color: #7a5200 !important;
}

.foz-total-alert-badge--high {
  border: 1px solid #e8a0a0 !important;
  background-color: #fdeaea !important;
  color: #9b1c1c !important;
}

.historic-text-cell {
  max-width: 86px;
  overflow: hidden;
  color: #374151;
  font-size: 12px;
  font-weight: 500;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.historic-observation {
  max-width: 96px;
  color: #5f6b7a;
}

.historic-file-cell,
.historic-actions-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 58px;
}

.historic-actions-cell {
  gap: 3px;
}

.historic-icon-button {
  width: 28px !important;
  height: 28px !important;
  border: 1px solid #e1e7ef;
  background-color: #ffffff;
}

.historic-icon-button:hover {
  background-color: #f2f7ff;
}

::v-deep .historic-table .v-data-table__wrapper {
  scrollbar-color: #9aa0a6 #f1f3f5;
}

::v-deep .historic-table table {
  border-collapse: separate;
  border-spacing: 0;
}

::v-deep .historic-table .v-data-table-header th {
  height: 44px;
  padding: 0 8px !important;
  background-color: #f8fafc;
  color: #4b5563 !important;
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
  vertical-align: middle;
}

::v-deep .historic-table .v-data-table-header th.sortable {
  min-width: 76px;
}

::v-deep .historic-table .v-data-table-header th:nth-child(2),
::v-deep .historic-table tbody td:nth-child(2),
::v-deep .historic-table .v-data-table-header th:nth-child(n+3):nth-child(-n+11),
::v-deep .historic-table tbody td:nth-child(n+3):nth-child(-n+11) {
  text-align: center !important;
}

::v-deep .historic-table .v-data-table-header__icon {
  margin-left: 4px;
}

::v-deep .historic-table tbody tr {
  transition: background-color 0.16s ease;
}

::v-deep .historic-table tbody tr:hover {
  background-color: #f8fbff !important;
}

::v-deep .historic-table tbody td {
  height: 60px;
  padding: 0 8px !important;
  border-bottom: 1px solid #eef2f6 !important;
  vertical-align: middle;
}

::v-deep .historic-table .v-input {
  font-size: 14px;
}

::v-deep .historic-table .v-text-field > .v-input__control > .v-input__slot::before {
  border-color: #d4d9df !important;
}

::v-deep .historic-table .v-text-field > .v-input__control > .v-input__slot::after {
  border-color: #8aa7c2 !important;
}

::v-deep .historic-table .v-label {
  color: #7b8490;
}

::v-deep .historic-table .v-chip {
  font-weight: 600;
}

::v-deep .historic-table tbody tr:nth-child(even) {
  background-color: #fcfdff;
}

@keyframes foz-skeleton-loading {
  0% {
    background-position: 100% 0;
  }

  100% {
    background-position: -100% 0;
  }
}
</style>
